module.exports = __webpack_public_path__ + "static/13-insights-6cc2677695ce5523d6b328969bcd9705.jpg";